import { render, staticRenderFns } from "./PromotionUser.vue?vue&type=template&id=264179ec&scoped=true"
import script from "./PromotionUser.vue?vue&type=script&lang=js"
export * from "./PromotionUser.vue?vue&type=script&lang=js"
import style0 from "./PromotionUser.vue?vue&type=style&index=0&id=264179ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264179ec",
  null
  
)

export default component.exports